import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const UnitedKingdomLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'UK',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'United Kingdom',
  SHORT_NAME: 'UK',

  DISPLAY_NAME: 'United Kingdom (English)',
  DISPLAY_COUNTRY: 'United Kingdom (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 54.5512799,
    INITIAL_LONGITUDE: -4.4737716,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Aberdeenshire',
    '2': 'Angus',
    '3': 'Antrim',
    '4': 'Argyll',
    '5': 'Armagh',
    '6': 'Ayrshire',
    '7': 'Banffshire',
    '8': 'Bedfordshire',
    '9': 'Berkshire',
    '10': 'Berwickshire',
    '11': 'Bristol',
    '12': 'Buckinghamshire',
    '13': 'Bute',
    '14': 'Caithness',
    '15': 'Cambridgeshire',
    '16': 'Cheshire',
    '17': 'City of London',
    '18': 'City of Aberdeen',
    '19': 'City of Belfast',
    '20': 'City of Derry',
    '21': 'City of Dundee',
    '22': 'City of Edinburgh',
    '23': 'City of Glasgow',
    '24': 'Clackmannanshire',
    '25': 'Clwyd',
    '26': 'Cornwall',
    '27': 'Cumbria',
    '28': 'Derbyshire',
    '29': 'Devon',
    '30': 'Dorset',
    '31': 'Down',
    '32': 'Dumfriesshire',
    '33': 'Dunbartonshire',
    '34': 'Durham',
    '35': 'Dyfed',
    '36': 'East Lothian',
    '37': 'East Riding of Yorkshire',
    '38': 'East Sussex',
    '39': 'Essex',
    '40': 'Fermanagh',
    '41': 'Fife',
    '42': 'Gloucestershire',
    '43': 'Greater London',
    '44': 'Greater Manchester',
    '45': 'Gwent',
    '46': 'Gwynedd',
    '47': 'Hampshire',
    '48': 'Herefordshire',
    '49': 'Hertfordshire',
    '50': 'Inverness-shire',
    '51': 'Isle of Wight',
    '52': 'Kent',
    '53': 'Kincardineshire',
    '54': 'Kinross-shire',
    '55': 'Kirkcudbrightshire',
    '56': 'Lanarkshire',
    '57': 'Lancashire',
    '58': 'Leicestershire',
    '59': 'Lincolnshire',
    '60': 'Londonderry',
    '61': 'Merseyside',
    '62': 'Mid Glamorgan',
    '63': 'Midlothian',
    '64': 'Moray',
    '65': 'Nairnshire',
    '66': 'Norfolk',
    '67': 'North Yorkshire',
    '68': 'Northamptonshire',
    '69': 'Northumberland',
    '70': 'Nottinghamshire',
    '71': 'Orkney',
    '72': 'Oxfordshire',
    '73': 'Peeblesshire',
    '74': 'Perthshire',
    '75': 'Powys',
    '76': 'Renfrewshire',
    '77': 'Ross and Cromarty',
    '78': 'Roxburghshire',
    '79': 'Rutland',
    '80': 'Selkirkshire',
    '81': 'Shetland',
    '82': 'Shropshire',
    '83': 'Somerset',
    '84': 'South Glamorgan',
    '85': 'South Yorkshire',
    '86': 'Staffordshire',
    '87': 'Stirlingshire',
    '88': 'Suffolk',
    '89': 'Surrey',
    '90': 'Sutherland',
    '91': 'Tyne and Wear',
    '92': 'Tyrone',
    '93': 'Warwickshire',
    '94': 'West Glamorgan',
    '95': 'West Lothian',
    '96': 'West Midlands',
    '97': 'West Sussex',
    '98': 'West Yorkshire',
    '99': 'Wigtownshire',
    '100': 'Wiltshire',
    '101': 'Worcestershire',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/uk/en/',

  MAP_URL: 'https://www.uniqlo.com/uk/en/content/Stores_Landing_UK.html',
  MAP_MOBILE_URL: 'https://map.uniqlo.com/uk/en/',

  CONTACT_US_URL: 'https://faq-uk.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-uk.uniqlo.com/pkb_Home?id=kA13z000000LMMS&l=en_US&c=category_uq_eu_dk_se%3AUQUK_C7_3&fs=Search&pn=1',
  PRIVACY_POLICY_URL:
    'https://faq-uk.uniqlo.com/pkb_Home?id=kA13z000000XlkE&l=en_US&c=category_uq_eu_dk_se%3AUQUK_C7_2&fs=Search&pn=1',

  POSTCODE_FORMAT: /^([0-9a-zA-Z]{2,4}) ([0-9a-zA-Z]{3})$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.MILE,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default UnitedKingdomLocale
